import './App.css';
import React, { useEffect, useState } from "react";
import Login from './Components/Common/login'
import Home from './Components/Common/Home'
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import ClientCreateAccount from './Components/Client/Pages/ClientCreateAccount';
import CounsellorCreateAccount from './Components/Counsellor/Pages/CounsellorCreateAccount';
import CounsellorRegistration from './Components/Counsellor/Pages/CounsellorRegistration';
import Counsellordashboard from './Components/Counsellor/Pages/CounsellorDashboard';
import PatientDetails from './Components/Client/Pages/PatientDetails';
import NonPatientPersonalDetails from './Components/Client/Pages/NonPatientPersonalDetails';
import SetAvailability from './Components/Counsellor/Pages/SetAvailability';
import Integrations from './Components/Counsellor/Pages/Integrations';
import CounsellorProfile from './Components/Counsellor/Pages/CounsellorProfile';
import CancerDetails from './Components/Client/Pages/CancerDetails';
import GoogleOAuthLogin from "./Components/Counsellor/Pages/GoogleOAuthLogin";
import PsychologicalInformation from './Components/Client/Pages/Psychologicalnformation';
import ContactUs from './Components/Common/Pages/ContactUs';
import PrivacyPolicy from './Components/Common/Pages/PrivacyPolicy';
import AboutUs from './Components/Common/Pages/AboutUs';
import ConfirmAndPay from './Components/Client/Pages/ConfirmAndPay';
import PaymentConfirmed from './Components/Client/Pages/PaymentConfirmed';
import ZoomSettings from './Components/Counsellor/Pages/ZoomSettings';
import { API_URL } from './Constant';
import AppointmentBooking from './Components/Client/Pages/AppointmentBooking';
import TermsOfUse from './Components/Common/Pages/TermsOfUse';
import Support from './Components/Common/Pages/Support';
import Documentation from './Components/Common/Pages/Documentation';
import Install from './Components/Common/Pages/Install';
import ClientCounsellorList from './Components/Client/Pages/ClientCounsellorList';
import ClientCounsellorProfile from './Components/Client/Pages/ClientCounsellorProfile';
import ClientDashboard from './Components/Client/Pages/ClientDashboard';
import CounsellorFees from './Components/Counsellor/Pages/CounsellorFees';
import BookAppointment from './Components/Client/Pages/BookAppointment';
import CounsellorSettings from './Components/Counsellor/Pages/CounsellorSettings';
import CounsellorAppointments from './Components/Counsellor/Pages/CounsellorAppointments';
import AdminDashboard from './Components/Admin/AdminDashboard';
import AdminCounsellorList from './Components/Admin/AdminCounsellorList';
import ClientProfile from './Components/Client/Pages/ClientProfile';
import ClientReceipt from './Components/Client/Pages/ClientReceipt';
import ForgotPassword from './Components/Common/ForgotPassword';
import Home2 from './Components/Common/Home2';
import Login2 from './Components/Common/Login2';
import BecomeCounsellor from './Components/Counsellor/Pages/BecomeCounsellor';
function App() {
  const [selectedCounsellor, setSelectedCounsellor] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const OAuthRedirectHandler = () => {
    const navigate = useNavigate();
    const [accessToken, setAccessToken] = useState("");
    const [refreshToken, setRefreshToken] = useState("");

    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const authorizationCode = urlParams.get("code");
      console.log("Authorization Code:", authorizationCode);
      if (authorizationCode) {
        // Send the authorization code to the backend to exchange for tokens
        fetch(API_URL + "api/auth/exchange-code", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ authorizationCode }),
        })
          .then((response) => response.json())
          .then((data) => {
            setAccessToken(data.accessToken);
            setRefreshToken(data.refreshToken);
            console.log("Access Token:", data.accessToken);
            console.log("Refresh Token:", data.refreshToken);
            // Navigate to the dashboard or desired page after successful login
            navigate("/admin/dashboard");
          })
          .catch((error) => {
            console.error("Error exchanging authorization code:", error);
          });
      }
    }, [navigate]);

    return (
      <div>
        <h2>Handling OAuth Redirect...</h2>
        {accessToken && <p>Access Token: {accessToken}</p>}
        {refreshToken && <p>Refresh Token: {refreshToken}</p>}
      </div>
    );
  };

  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        {/* common */}
        <Route path="/Login" element={<Login />} />
        <Route path="/Login2" element={<Login2 />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/TermsOfUse" element={<TermsOfUse />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/Support" element={<Support />} />
        <Route path="/Documentation" element={<Documentation />} />
        <Route path="/Install" element={<Install />} />
        <Route path="/Home2" element={<Home2/>}/>

        {/* client */}
        <Route path="/create-account" element={<ClientCreateAccount />} />
        <Route path="/client/patient-details" element={<PatientDetails />} />
        <Route path="/client/non-patient-personal-details" element={<NonPatientPersonalDetails />} />
        <Route path="/client/CancerDetails" element={<CancerDetails />} />
        <Route path="/client/PsychologicalInformation" element={<PsychologicalInformation />} />
        <Route path="/client/book-appointment" element={<AppointmentBooking />} />
        <Route path="/client/ClientCounsellorList" element={<ClientCounsellorList />} />
        <Route path="/client/ClientCounsellorProfile/:counsellorId" element={<ClientCounsellorProfile />} />
        <Route path="/client/ConfirmAndPay" element={<ConfirmAndPay />} />
        <Route path="/client/PaymentConfirmed" element={<PaymentConfirmed />} />
        <Route path="/client/ClientDashboard" element={<ClientDashboard />} />
        <Route path="/client/availability/:counsellorId" element={<BookAppointment />} />
        <Route path="/client/ClientProfile" element={<ClientProfile />} />
        <Route path="/client/ClientReceipt" element={<ClientReceipt />} />

        {/* counsellor */}
        <Route path='/create-counsellor-account' element={<CounsellorCreateAccount />} />
        <Route path='/counsellor/register' element={<CounsellorRegistration />} />
        <Route path='/counsellor/dashboard' element={<Counsellordashboard />} />
        <Route path='/counsellor/availability' element={<SetAvailability />} />
        <Route path='/counsellor/integrations' element={<Integrations />} />
        <Route path='/counsellor/profile' element={<CounsellorProfile />} />
        <Route path="/oauth/google/redirect" element={<OAuthRedirectHandler />} />
        <Route path="/google-oauth-login" element={<GoogleOAuthLogin />} />
        <Route path="/counsellor/zoom" element={<ZoomSettings />} />
        <Route path="/counsellor/CounsellorFees" element={<CounsellorFees />} />
        <Route path="/counsellor/settings" element={<CounsellorSettings />} />
        <Route path="/counsellor/appointments" element={<CounsellorAppointments />} />
        <Route path="/counsellor/BecomeCounsellor" element={<BecomeCounsellor />} />
        {/* admin */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/AdminCounsellorList" element={<AdminCounsellorList />} />
      </Routes>
    </Router>
  );
}

export default App;
